import '../styles/GlobalDesign.css';
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : process.env.REACT_APP_API_URL || '/api';

const ResellerLogin = () => {
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showLoginPassword, setShowLoginPassword] = useState(false);
  const [showRegisterPassword, setShowRegisterPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  });

  const [registerData, setRegisterData] = useState({
    nom: '',
    email: '',
    password: '',
    confirmPassword: '',
    telephone: '',
    whatsapp: ''
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/resellers/login`, loginData);
      
      localStorage.setItem('resellerToken', response.data.token);
      localStorage.setItem('resellerData', JSON.stringify(response.data.reseller));
      
      navigate('/reseller/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (registerData.password !== registerData.confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    if (registerData.password.length < 6) {
      setError('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/resellers/register`, {
        nom: registerData.nom,
        email: registerData.email,
        password: registerData.password,
        telephone: registerData.telephone,
        whatsapp: registerData.whatsapp || registerData.telephone
      });

      setSuccess(`Compte créé avec succès ! Votre page personnalisée : ${response.data.pageUrl}`);
      
      // Auto-login après inscription
      setTimeout(() => {
        localStorage.setItem('resellerToken', response.data.token);
        localStorage.setItem('resellerData', JSON.stringify(response.data.reseller));
        navigate('/reseller/dashboard');
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de l\'inscription');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      {/* Navbar */}
      <nav className="new-design-navbar" style={{ position: 'fixed', top: 0 }}>
        <div className="new-design-container">
          <Link to="/" className="new-design-logo">
            <img src="/logo.png" alt="Fluxivo" className="new-design-logo-img" style={{height: '36px', width: 'auto'}} />
            <span className="new-design-logo-text">Flux<span>ivo</span></span>
          </Link>
          <Link to="/" className="new-design-btn-login">Retour</Link>
        </div>
      </nav>

      <div className="auth-page-container">
        <div className="auth-page-header">
          <h1 className="auth-page-title">
            🎯 Espace Revendeur
          </h1>
          <p className="auth-page-subtitle">Devenez partenaire et gagnez des commissions sur chaque vente</p>
        </div>

        <div className="auth-tabs-container">
          <button
            onClick={() => {
              setIsLogin(true);
              setError('');
              setSuccess('');
            }}
            className={`auth-tab-button ${isLogin ? 'active' : ''}`}
          >
            Connexion
          </button>
          <button
            onClick={() => {
              setIsLogin(false);
              setError('');
              setSuccess('');
            }}
            className={`auth-tab-button ${!isLogin ? 'active' : ''}`}
          >
            Inscription
          </button>
        </div>

        {error && <div className="auth-error-message">{error}</div>}
        {success && <div className="auth-success-message">{success}</div>}

        {isLogin ? (
          <form onSubmit={handleLogin}>
            <div className="new-design-form-group">
              <label>Email</label>
              <input
                type="email"
                value={loginData.email}
                onChange={(e) => setLoginData({ ...loginData, email: e.target.value })}
                required
                placeholder="votre@email.com"
              />
            </div>

            <div className="new-design-form-group">
              <label>Mot de passe</label>
              <div className="pwd-input-wrapper">
                <input
                  type={showLoginPassword ? "text" : "password"}
                  value={loginData.password}
                  onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                  required
                  placeholder="••••••••"
                />
                <button
                  type="button"
                  onClick={() => setShowLoginPassword(!showLoginPassword)}
                  className="toggle-pwd-btn"
                >
                  {showLoginPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
            </div>

            <div className="auth-link-right">
              <Link to="/reseller/forgot-password">
                Mot de passe oublié ?
              </Link>
            </div>

            <button type="submit" className="new-design-btn new-design-btn-primary" style={{ width: '100%' }} disabled={loading}>
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleRegister}>
            <div className="new-design-form-group">
              <label>Nom complet *</label>
              <input
                type="text"
                value={registerData.nom}
                onChange={(e) => setRegisterData({ ...registerData, nom: e.target.value })}
                required
                placeholder="Votre nom complet"
              />
            </div>

            <div className="new-design-form-group">
              <label>Email *</label>
              <input
                type="email"
                value={registerData.email}
                onChange={(e) => setRegisterData({ ...registerData, email: e.target.value })}
                required
                placeholder="votre@email.com"
              />
            </div>

            <div className="auth-grid-2col">
              <div className="new-design-form-group">
                <label>Téléphone</label>
                <input
                  type="tel"
                  value={registerData.telephone}
                  onChange={(e) => setRegisterData({ ...registerData, telephone: e.target.value })}
                  placeholder="+221 XX XXX XX XX"
                />
              </div>

              <div className="new-design-form-group">
                <label>WhatsApp</label>
                <input
                  type="tel"
                  value={registerData.whatsapp}
                  onChange={(e) => setRegisterData({ ...registerData, whatsapp: e.target.value })}
                  placeholder="+221 XX XXX XX XX"
                />
              </div>
            </div>

            <div className="new-design-form-group">
              <label>Mot de passe *</label>
              <div className="pwd-input-wrapper">
                <input
                  type={showRegisterPassword ? "text" : "password"}
                  value={registerData.password}
                  onChange={(e) => setRegisterData({ ...registerData, password: e.target.value })}
                  required
                  placeholder="Minimum 6 caractères"
                />
                <button
                  type="button"
                  onClick={() => setShowRegisterPassword(!showRegisterPassword)}
                  className="toggle-pwd-btn"
                >
                  {showRegisterPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
            </div>

            <div className="new-design-form-group">
              <label>Confirmer le mot de passe *</label>
              <div className="pwd-input-wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  value={registerData.confirmPassword}
                  onChange={(e) => setRegisterData({ ...registerData, confirmPassword: e.target.value })}
                  required
                  placeholder="Confirmer votre mot de passe"
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="toggle-pwd-btn"
                >
                  {showConfirmPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
            </div>

            <div className="auth-info-box">
              <p>💰 Gagnez jusqu'à <strong style={{ color: 'var(--primary-color)' }}>30% de commission</strong> sur chaque vente</p>
              <p>📊 Suivez vos revenus en temps réel</p>
              <p>💳 Retirez vos gains dès 1 000 FCFA</p>
            </div>

            <button type="submit" className="new-design-btn new-design-btn-primary" style={{ width: '100%' }} disabled={loading}>
              {loading ? 'Inscription...' : 'Créer mon compte revendeur'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResellerLogin;
